export type CaseStudy = {
  title: string;
  challenge: string;
  approach: string;
  result: string;
  tags: string[];
  images: { src: string; alt: string }[];
};

export const caseStudies: CaseStudy[] = [
  {
    title: 'Tin Plate EMI Shield Production',
    challenge:
      'Client lost access to their US vendor and only had an incomplete drawing with poor line weight for a folded tin EMI shield.',
    approach:
      'Extracted clean geometry from the legacy SVG, rebuilt the part in CAD with a flat pattern for laser cutting, and machined two acetal bending jigs; each performs all the bends in just two bench vise operations.',
    result:
      'Reduced what would have been eight bending passes down to two, enabling in house production without press brake tooling and slashing turnaround from weeks to days.',
    tags: ['Reverse Engineering', 'Custom Tooling', 'Sheet Metal', 'Cost Reduction'],
    images: [
      { src: '/images/finished-emi-shield.jpg', alt: 'Finished tin EMI shield on a workbench' },
      { src: '/images/folding-jig.jpg', alt: 'Two stage acetal bending jig designed for the shield' },
      { src: '/images/folding.gif', alt: 'Animated bending process using the custom jig' }
    ]
  },
  {
    title: 'DC Power Cable: Starquad Design',
    challenge:
      'High end audio equipment required DC power leads that rejected noise better than off the shelf options while fitting tight enclosures.',
    approach:
      'Specified Canare starquad speaker cable for natural noise cancellation, crimped low resistance terminations, and packaged the assembly with custom strain relief for repeatable installs.',
    result:
      'Delivered low noise harnesses that eliminated hum in sensitive stages and can be reproduced on demand with documented tooling and measurements.',
    tags: ['Cable Design', 'Audio', 'Custom Assembly', 'DC Power'],
    images: [
      { src: '/images/cables.jpg', alt: 'Custom cable assemblies laid out on the bench' },
      { src: '/images/cable-cutter.jpg', alt: 'Cable cutting and tooling setup in the shop' },
      { src: '/images/crimper.jpg', alt: 'Precision crimp tooling prepared for cable assembly' },
      { src: '/images/solder-jig.jpg', alt: 'Custom soldering jig supporting terminal work' }
    ]
  },
  {
    title: 'Shielded Data Cables',
    challenge:
      'Digital audio gear needed shield continuity through every termination to avoid signal loss between motherboard and DAC.',
    approach:
      'Selected Belden twisted pair conductors, maintained impedance through routing, and wrapped connectors with conductive copper tape to keep the shield continuous to the pins.',
    result:
      'Produced cable sets with measurably lower noise floors and detailed build notes so clients can reorder or scale to short runs without guesswork.',
    tags: ['Data Cables', 'Shielding', 'Signal Integrity'],
    images: [
      { src: '/images/tape-shield.jpg', alt: 'Continuous shield termination using copper tape' },
      { src: '/images/tape-shield-2.jpg', alt: 'Alternate view of cable shielding with copper tape' },
      { src: '/images/mobo-to-dobo.jpg', alt: 'Shielded cable routed between motherboard and DAC' },
      { src: '/images/cables-alt.jpg', alt: 'Close up of completed low noise cable harnesses' }
    ]
  }
];
